@if (!isPlaying() && hasBegin()) {
  <app-pause-overlay />
}

@if (!dataIsLoaded()) {
  <app-loader-overlay />
} @else {
  <main class="coaching-stage">
    @if (videoUrl()) {
      <app-screen-video class="coaching-video" [videoUrl]="videoUrl()!" />
    }

    @if (!isImmerssiveMode() && datasEnabled() && hasBegin() && isPlaying()) {
      <app-screen-datas class="coaching-datas" layout="coaching" [dataBlocks]="dataBlocks()" />
    }

    @if (!isImmerssiveMode() && resistanceBlockEnabled() && hasBegin() && isPlaying()) {
      <app-resistance class="coaching-resistance" />
    }

    @if (!isImmerssiveMode() && chartEnabled() && hasBegin() && isPlaying()) {
      <footer class="coaching-footer">
        <app-chart-current-segment-info variant="coaching" />

        <app-intervals-timeline
          [intervals]="coachingIntervals()"
          [currentTime]="currentTime()"
          [totalDuration]="totalDuration()"
          [centered]="timelineIsCentered()"
        />

        <app-chart-next-segment-info variant="coaching" />
      </footer>
    }
  </main>
}
